// external modules
import { Trans, useTranslation } from "react-i18next";
// components
import SubTitle from "../@common/SubTitle/SubTitle";
import Title from "../@common/Title/Title";
import ImageRenderer from "components/@common/ImageRenderer/ImageRenderer";
import styles from "./Step1.module.scss";
import { getIntroStepImage } from "utils/(assets)";

export default function Step1() {
  const { t, i18n } = useTranslation();

  const STEP_1_IMAGE_URL = getIntroStepImage({
    i18n,
    stepNumber: 1,
  });

  return (
    <section className={styles["wrapper-step1"]}>
      <div className={styles["wrap-step1"]}>
        <SubTitle>{t("세계가 인정한 두피 분석 솔루션")}</SubTitle>
        <Title>
          <Trans t={t} i18nKey="AI 두피/탈모 관리 솔루션" components={{ br: <br /> }} />
        </Title>
      </div>
      <div className={styles["wrap-step1-img"]}>
        <ImageRenderer src={STEP_1_IMAGE_URL} />
      </div>
    </section>
  );
}
